<template>
  <div class="step-list">
    <div
      class="step-item"
      :class="{ 'step-item-active': index <= active }"
      v-for="(item, index) in data"
      :key="index"
    >
      <div class="item-top">
        <div class="item-dot">{{ index + 1 }}</div>
        <div class="item-line"></div>
      </div>
      <div class="item-text">{{ item }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: ['餐卡评分', '餐卡点评', '发布点评']
    }
  }
}
</script>
<style lang="scss" scoped>
.step-list {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-bottom: 25px;
  .step-item {
    flex: 1;
    position: relative;
    .item-top {
      display: flex;
      align-items: center;
    }
    .item-dot {
      width: 24px;
      height: 24px;
      background: #e7e7e7;
      border-radius: 12px;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
    .item-line {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      height: 4px;
      background: #e7e7e7;
    }
    .item-text {
      position: absolute;
      white-space: nowrap;
      font-size: 12px;
      display: inline-block;
      margin-top: 8px;
      margin-left: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      transform: translate(-50%, 0%);
    }
  }
  .step-item-active {
    .item-dot {
      background: #6236ff;
    }
    .item-line {
      background: #6236ff;
    }
    .item-text {
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .step-item:last-child {
    flex: 0 0 auto;
  }
}
</style>
